<template>
  <!-- This isn't the real map -->
  <div id="map" ref="map" aria-hidden="true" role="presentation" tabindex="-1"></div>
</template>

<style scoped>
#map {
  visibility: hidden;
  height: 10px;
  width: 10px;
}
</style>

<script>
import { useRootStore } from "../store";

/*eslint no-undef: */

// Generates a Bing Map with Session Key, then sends it to the Vuex store.
// This key is used to reduce the number of bing maps credits required for the thumbnails.

export default {
  name: "BingSession",
  computed: {
    getMapAPIkey() {
      return this.rootStore.mapAPIkey;
    },
  },
  data() {
    return {
      rootStore: useRootStore(),
    }
  },
  mounted() {
    if (document.getElementById("scriptBingMaps")) {
      return; // already loaded, done.
    }

    // Add a global function for the callback from Bing Maps api
    window.OnLoadBingMapsApi = () => this.InitMap();

    // Add programmaticaly the external Bing maps api script
    const scriptTag = document.createElement("script");
    scriptTag.src =
      "https://www.bing.com/api/maps/mapcontrol?callback=OnLoadBingMapsApi&key=" +
      this.getMapAPIkey;
    scriptTag.id = "scriptBingMaps";
    scriptTag.defer = true;
    scriptTag.async = true;

    // Inject the dynamic script in the DOM
    document.head.appendChild(scriptTag);
  },
  methods: {
    getSession: function () {
      const thisCred = this;
      
      // console.log(this.getMapAPIkey)
      // Updates VUEX Store with session key
      thisCred.map.getCredentials(function (c) {
        return this.rootStore.UPDATE_MAP_API_KEY(c);
      });
      console.log(this.getMapAPIkey);
        // Hide the map container after session key is obtained
      if (thisCred.$refs.map) {
        thisCred.$refs.map.parentNode.removeChild(thisCred.$refs.map);
      }
    },

    InitMap: function () {
      const mapElement = document.getElementById("map");

      this.map = new Microsoft.Maps.Map(mapElement, {
        liteMode: true,
      });

      this.getSession();
    },
  }
};
</script>